import { createFileRoute } from '@tanstack/react-router'
import { withOrgReset } from '@/components/glitch-ui/with-org-reset'
import { Performance } from '../index'

// Per-campaign deep link into the legacy Performance page; the page reads the
// slug from the path.
export const Route = createFileRoute(
  '/_authenticated/_layout/performance/$campaignSlug/',
)({
  component: withOrgReset(Performance),
})
